var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrackingDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#2DD186"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5568 13.4139C28.7757 12.6329 27.5094 12.6329 26.7284 13.4139L16.9854 23.1569L13.0646 19.2362C12.2836 18.4551 11.0172 18.4551 10.2362 19.2362C9.45513 20.0172 9.45513 21.2836 10.2362 22.0646L15.6004 27.4288C16.3814 28.2099 17.6478 28.2099 18.4288 27.4288C18.5273 27.3303 18.6134 27.2241 18.6871 27.1121L29.5568 16.2423C30.3378 15.4613 30.3378 14.195 29.5568 13.4139Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackingDone);
export default __webpack_public_path__ + "static/media/tracking-done.1f91e232361a41c9d0f65c7ac1178bf7.svg";
export { ForwardRef as ReactComponent };